import React, { Component } from 'react'
import { Row, Input, Button, Modal, Card } from 'antd'
import { api, app } from '../../app'
import Head from '../../components/Head'
import Iconz from '../../components/Iconz'

class SUpdatePlayer extends Component {
    constructor (props) {
        super(props)
        this.state = {
            info: null,
            untying_loading: false
        }
    }

    componentDidMount () {
        this._isMounted = true
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 搜索
     * @param value
     */
    handleSearch = async (value) => {
        if (!value) {
            app.alert('请输入队员编号', 'warn')
            return false
        }
        app.alert('正在搜索...', 'loading', '45%', 0)
        const { flag, data, msg } = await app.post(api.UserSearchBsrno, {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            bsrno: value
        })
        app.alertDestroy()
        if (flag === 1) {
            await this.setData({ info: data })
        } else {
            app.alert(msg, 'error')
        }
    }

    /**
     * 解绑微信小程序
     * @returns {Promise<boolean>}
     */
    handleUntyingWXApp = async () => {
        if (this.state.untying_loading) return false
        const { info } = this.state
        await this.setData({ untying_loading: true })
        const { flag, msg } = await app.post(api.UserUntiedApplets, {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            object_indexno: info.indexno
        })
        if (flag === 1) {
            app.alert(msg, 'success')
        } else {
            app.alert(msg, 'error')
        }
        await this.setData({ untying_loading: false })
        await this.handleSearch(info.bsrno)
    }

    /**
     * 修改队员身份证/姓名
     * @returns {Promise<boolean>}
     */
    handleUpdateIdnoOrName = async (data) => {
        const { info } = this.state
        const { flag, msg } = await app.post(api.UserCardNameSave, {
            ...data,
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            object_indexno: info.indexno
        })
        if (flag === 1) {
            app.alert(msg, 'success')
            return true
        } else {
            app.alert(msg, 'error')
            return false
        }
    }

    /**
     * 编辑
     * @param type
     * @returns {Promise<boolean>}
     */
    handleEdit = async (type) => {
        const { info } = this.state
        if (!info && !info.indexno) {
            app.alert('请先搜索队员！', 'warn')
            return false
        }
        let title = '', content = null, value = '', key = ''
        switch (type) {
            case '1':
                title = '修改身份证'
                key = 'idno'
                content = (
                    <Input placeholder="请输入新的身份证" onChange={e => {
                        value = e.target.value
                    }}/>
                )
                break
            case '2':
                title = '修改姓名'
                key = 'vname'
                content = (
                    <Input placeholder="请输入新的姓名" onChange={e => {
                        value = e.target.value
                    }}/>
                )
                break
            case '3':
                title = '确定解绑微信小程序吗？'
                break
        }
        let loading = false
        Modal.confirm({
            title,
            content,
            centered: true,
            confirmLoading: loading,
            onOk: async () => {
                if (type === '3') {
                    await this.handleUntyingWXApp()
                } else {
                    if (!value) {
                        app.alert('请输入再修改', 'warn')
                        return Promise.reject(false)
                    }
                    if (info[key] === value) {
                        app.alert('与原信息相同无需修改', 'warn')
                        return Promise.reject(false)
                    }
                    loading = true
                    let flag = await this.handleUpdateIdnoOrName({ [key]: value, type })
                    loading = false
                    if (flag) {
                        await this.handleSearch(info.bsrno)
                        return true
                    }
                    else return Promise.reject(false)
                }
            }
        })
    }

    render () {
        const { info, untying_loading } = this.state
        return (
            <div style={{ height: '100%' }}>
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48}/>
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history}/>
                <div style={{ height: 'calc(100% - 78px)', overflow: 'auto' }}>
                    <div style={{ width: 600, margin: '30px auto 0 auto', padding: 15 }}>
                        <Input.Search
                            placeholder="请输入队员编号进行搜索"
                            enterButton="搜索"
                            size="large"
                            onSearch={this.handleSearch}
                        />
                        {
                            info ? (
                                <Card title="当前信息"
                                      style={{ marginTop: 30 }}
                                      actions={[
                                          (<Button onClick={() => this.handleEdit('1')} type="primary" icon="idcard">修改身份证</Button>),
                                          (<Button onClick={() => this.handleEdit('2')} type="primary" icon="user">修改姓名</Button>),
                                          (<Button loading={untying_loading} disabled={!info.openid} onClick={() => this.handleEdit('3')} type="primary" icon="disconnect">解绑微信</Button>)
                                      ]}>
                                    <div style={{ padding: '10px 0' }}>队员编号：{info.bsrno || ' - '}</div>
                                    <div style={{ padding: '10px 0' }}>队员姓名：{info.vname || ' - '}</div>
                                    <div style={{ padding: '10px 0' }}>身份证号：{info.idno || ' - '}</div>
                                    <div style={{ padding: '10px 0' }}>是否绑定微信小程序：{info.openid === 1 ? '是' : '否'}</div>
                                </Card>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default SUpdatePlayer



// WEBPACK FOOTER //
// ./src/routes/super/SUpdatePlayer.jsx